import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { HexBadgeModule } from "@hex/angular/badge";
import { HexButtonModule } from "@hex/angular/button";
import { HexButtonGroupModule } from "@hex/angular/button-group";
import { HexConduitModule } from "@hex/angular/conduit";
import { HexDataListModule } from "@hex/angular/data-list";
import { HexDialogModule } from "@hex/angular/dialog";
import { HexFlyInModule } from "@hex/angular/fly-in";
import { HexIconModule } from "@hex/angular/icon";
import { HexLinkModule } from "@hex/angular/link";
import { HexPopoverModule } from "@hex/angular/popover";
import { HexRuleModule } from "@hex/angular/rule";
import { HexSwitchModule } from "@hex/angular/switch";
import { HexTextModule } from "@hex/angular/text";
import { TechProfilesListActions } from "../+authenticated/+customer-master/customer-detail/tech-profiles/tech-profiles-list-actions";
import { TechProfilesListEpics } from "../+authenticated/+customer-master/customer-detail/tech-profiles/tech-profiles-list-epics";
import { TechProfilesListService } from "../+authenticated/+customer-master/customer-detail/tech-profiles/tech-profiles-list-service";
import { CommonFormModule } from "./components/common-form/common-form.module";
import { CommonListModule } from "./components/common-list/common-list.module";
import { CommonMultiselectFilterModule } from "./components/common-multiselect-filter/common-multiselect-filter.module";
import { CommonSearchbarModule } from "./components/common-searchbar/common-searchbar.module";
import { CommonStaticFilterModule } from "./components/common-static-filter/common-static-filter.module";
import { CommonToggleDisplayModule } from "./components/common-toggle-display/common-toggle-display.module";
import { CommonToggleFilterModule } from "./components/common-toggle-filter/common-toggle-filter.module";
import { CommonUtilsModule } from "./components/common-utils/common-utils.module";
import { FileAttachmentManagerModule } from "./components/file-attachment-manager/file-attachment-manager.module";
import { ModifiersModule } from "./components/presentational/modifiers/modifiers.module";
import { SectionsModule } from "./components/presentational/sections/sections.module";
import { RowSelectionModule } from "./components/row-selection/row-selection.module";
import { StatefulContainerModule } from "./components/stateful-container/stateful-container.module";
import { TogglePostActionModule } from "./components/toggle-post-action/toggle-post-action.module";
import { LocalAssetRequestService } from "./graphql/local-asset-requests.service";
import { ResponseService } from "./graphql/response.service";
import { SharedPipesModule } from "./pipes";
import { RootEpics } from "./redux/root.epics";
import { NSAngular } from "./types";

export const APP_MODULE_IMPORTS = [
    RouterModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    CommonFormModule,
    CommonListModule,
    CommonSearchbarModule,
    CommonStaticFilterModule,
    CommonMultiselectFilterModule,
    CommonToggleDisplayModule,
    CommonToggleFilterModule,
    CommonUtilsModule,

    SharedPipesModule,
    SectionsModule,
    ModifiersModule,
    StatefulContainerModule,
    RowSelectionModule,
    TogglePostActionModule,
    FileAttachmentManagerModule,

    HexFlyInModule,
    HexPopoverModule,
    HexConduitModule,
    HexDataListModule,
    HexButtonModule,
    HexButtonGroupModule,
    HexIconModule,
    HexBadgeModule,
    HexTextModule,
    HexRuleModule,
    HexLinkModule,
    HexSwitchModule,
    HexDialogModule,
];

export const APP_MODULE_PROVIDERS: NSAngular.Provider[] = [
    RootEpics,
    TechProfilesListEpics,
    TechProfilesListService,
    TechProfilesListActions,
    LocalAssetRequestService,
    ResponseService,
];

export const APP_MODULE_DECLARATIONS: NSAngular.Declaration[] = [

];

export const EXPORTS: NSAngular.Declaration[] = [
    ...APP_MODULE_DECLARATIONS,
    ...APP_MODULE_IMPORTS,
];

@NgModule({
    declarations: APP_MODULE_DECLARATIONS,
    exports: EXPORTS,
    imports: [...APP_MODULE_IMPORTS],
    providers: APP_MODULE_PROVIDERS,
})
export class SharedModule { }
